module.exports = __webpack_public_path__ + "cd455783/img/note-list-icon.961c1485.svg";